export enum GENDER {
  Female,
  Male
}

export interface ICustomer {
  id?: number;
  userGender?: number;
  userIdentityNumber?: string;
  userMobile?: string;
  userName?: string;
}

interface IState {
  orderId: string;
  customerList: ICustomer[];
  storeInfo: any;
  customerInfo: ICustomer;
  timeRange: {
    begin: string;
    end: string;
  };
  bookingDate: string;
  bookingTime: string;
}

const initState: IState = {
  orderId: '',
  customerList: [],
  storeInfo: {
    svcName: '',
    organizationId: '',
    serverId: '',
    expireTime: '',
    storeName: '',
    isUpdate: false
  },
  customerInfo: {},
  bookingDate: '',
  bookingTime: '',
  timeRange: {
    begin: '',
    end: ''
  }
};

const covid = {
  state: initState,
  reducers: {
    updateState(state: IState, payload) {
      return {
        ...state,
        ...payload
      };
    },

    updateCustomerInfo(state: IState, payload) {
      return {
        ...state,
        customerInfo: payload
      };
    },

    updateCustomerList(state, payload) {
      return {
        ...state,
        customerList: payload
      };
    }
  },

  effects: (_dispatch) => ({})
};

export default covid;
